export default "__VITE_PUBLIC_ASSET__a10852de__"